import { Indicator } from 'is24-corecss';
import React from 'react';
import { TeamMemberLifecycleSnapshot } from './LifecycleSnapshot';
import styles from '../components/teamManagement/components/table/styles.module.css';

export type TeamMemberStatus =
  | 'CREATED'
  | 'INVITED'
  | 'INVITATION_FAILED'
  | 'INVITATION_EXPIRED'
  | 'INVITATION_REVOKED'
  | 'INVITATION_ACCEPTED'
  | 'ACTIVATED'
  | 'DEACTIVATED';

const statusTranslations: Record<TeamMemberStatus, string> = {
  CREATED: 'Erstellt',
  INVITED: 'Ausstehend',
  INVITATION_FAILED: 'Fehlgeschlagen',
  INVITATION_EXPIRED: 'Abgelaufen',
  INVITATION_REVOKED: 'Widerrufen',
  INVITATION_ACCEPTED: 'Einladung angenommen',
  ACTIVATED: 'Aktiv',
  DEACTIVATED: 'Inaktiv',
};

const statusTranslationsLayout: Record<TeamMemberStatus, string> = {
  CREATED: styles.statusCell,
  INVITED: styles.statusCellInvited,
  INVITATION_FAILED: styles.statusCellInvited,
  INVITATION_EXPIRED: styles.statusCellInvited,
  INVITATION_REVOKED: styles.statusCellInvited,
  INVITATION_ACCEPTED: styles.statusCellInvited,
  ACTIVATED: styles.statusCell,
  DEACTIVATED: styles.statusCellInactive,
};

export const statusMapper = (status: string | null | undefined): string => {
  return statusTranslations[status as TeamMemberStatus] || 'Unbekannt';
};

export const getStatus = (row: TeamMember): JSX.Element => {
  const status = statusMapper(row['status']);
  const statusStyle = statusTranslationsLayout[row['status'] as TeamMemberStatus];
  if (row['isTwoFactorEnabled']) {
    return (
      <div>
        <Indicator appearance='label' data-testid='2FATag' className={styles.statusCell}>
          Aktiv mit 2FA
        </Indicator>
        <span className='is24-icon-info' />
      </div>
    );
  }
  return (
    <Indicator appearance={'label'} className={statusStyle}>
      {status}
    </Indicator>
  );
};

export type TeamMemberJobTitle = 'MANAGEMENT' | 'MARKETING' | 'SECRETARIAT' | 'SALES' | 'RESEARCH_AND_DATA_ANALYSIS' | 'OTHER';

const jobTitleTranslations: Record<TeamMemberJobTitle, string> = {
  MANAGEMENT: 'Geschäftsführung',
  MARKETING: 'Marketing',
  SECRETARIAT: 'Sekretariat',
  SALES: 'Vertrieb',
  RESEARCH_AND_DATA_ANALYSIS: 'Research & Datenanalyse',
  OTHER: 'Sonstiges',
};

export const jobTitleMapper = (jobTitle: string | null | undefined): string => jobTitleTranslations[jobTitle as TeamMemberJobTitle] || 'Unbekannt';

export const teamMemberJobTitles: Array<TeamMemberJobTitle> = [
  'MANAGEMENT',
  'MARKETING',
  'SECRETARIAT',
  'SALES',
  'RESEARCH_AND_DATA_ANALYSIS',
  'OTHER',
];

export type TeamMember = {
  id?: string;
  email?: string;
  username?: string;
  salutation?: string;
  firstName?: string;
  lastName?: string;
  note?: string | null;
  status?: TeamMemberStatus;
  isTwoFactorEnabled?: boolean;
  modifiedAt?: string | null;
  readonly lifecycleSnapshot?: TeamMemberLifecycleSnapshot;
  jobTitle?: TeamMemberJobTitle;
};
